import * as React from 'react';
import { BaseButton, ButtonLook, ButtonProps } from './base_button';

export const DefaultButton = (props: ButtonProps) => (
  <BaseButton look={ButtonLook.DEFAULT} {...props}/>
);
